<!--  -->
<template>
  <div id="my">
    <div class="container">
      <div class="info"></div>
      <div class="info info2"></div>
      <div class="info info3"></div>
    </div>
    <div class="userinfo-warp">
    <!-- <div class="userinfo-warp" @click="toYfy()"> -->
      <van-image class="user-left"  :src="userInfo.HeadImgUrl" >
                <template #error>
  <van-image :src="`https://www.riceyfy.com${userInfo.HeadImgUrl}`" class="user-left"  />
        </template>
        </van-image>
      <div class="user-right">
        <div class="user-right-left">

               <span>[{{userInfo.id}}] {{userInfo.ShopName}}</span>
          <br />
          <span>{{userInfo.Phone}}</span>
        </div>
        <div class="user-right-right" >
              <van-icon name="qr"  size="40"/><br>
              v1
        </div>
      </div>
    </div>
    <div class="order-warp">
      <van-grid :border="false" :column-num="4">
        <van-grid-item @click="toOrderList(1)">
          <van-image :src="require('../../../src/assets/icons/dfh.png')" />
          <span>待发货</span>
        </van-grid-item>
        <van-grid-item @click="toOrderList(2)">
          <van-image :src="require('../../../src/assets/icons/dsh.png')" />
          <span>待收货</span>
        </van-grid-item>
        <van-grid-item @click="toOrderList(3)">
          <van-image :src="require('../../../src/assets/icons/dfk.png')" />
          <span>待收款</span>
        </van-grid-item>
        <van-grid-item @click="toOrderList(4)">
          <van-image :src="require('../../../src/assets/icons/ywc.png')" />
          <span>已完成</span>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="cells-warp">


      <van-cell-group>
        <van-cell icon="balance-list" title="全部订单" @click="toOrderList()" is-link>
          <template #icon>
            <van-icon name="balance-list" style="line-height: inherit;" size="20" color="#ffc053" />
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group>
        <van-cell icon="map-marked" title="地址管理" @click="toPage('address')" is-link value >
        <template #icon>
            <van-icon name="map-marked" style="line-height: inherit;" size="20" color="#ffc053" />
          </template>
        </van-cell>
        <van-cell icon="star" title="我的收藏" @click="toPage('collection')" is-link value >
        <template #icon>
            <van-icon name="star" style="line-height: inherit;" size="20" color="#ffc053" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Image as VanImage, Grid, GridItem, Cell, CellGroup, Icon,Dialog } from "vant";
import api from '../../api/login'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    [VanImage.name]: VanImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    //这里存放数据
    return {
      userInfo: '',
      openid:''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
      toOrderList(val){
        this.$router.push({
          name:'orderList',
          query : {
            type: val
          }
        })
      },
      toPage(name){
        this.$router.push({name})
      },
      toYfy(){
          let url="https://www.riceyfy.com/wx/usercenter.php?openid="+this.openid+'&time='+((new Date()).getTime());
        Dialog.alert({
          message: url,
        }).then(() => {
        
           location.href=url
        });
       
      }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let userInfo= localStorage.getItem('userInfo')
    console.log('userInfo',userInfo)
    if(userInfo){
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
    
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
      console.log('this.$store.state.userInfo',this.$store.state.userInfo)
          let a=localStorage.getItem('openid')
    this.openid=a
      console.log('openid',this.openid)
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {
    if(!this.userInfo.id){
      api.userInfo({hideLoading:true}).then(res=>{
        if(res.status==0){
          this.$store.commit('setUserInfo', res.result)
          this.userInfo = res.result
        }
      })
    }
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
#my {
  background-color: #f5f5f5;
  height: 100vh;
  width: 100%;
}
.container {
  position: absolute;
  width: 100vw;
  height: 150px;
  left: 50%;
  top: 75px;
  transform: translate(-50%, -50%);
  background-color: #f19800;
  overflow: hidden;
  /* z-index:999; */
}

.info {
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 1);
  top: 80%;
  border-radius: 55%;
  border: 0px solid red;
  left: 50%;
  transform: translate(-50%, 0);
}

.info2 {
  left: 0;
}

.info3 {
  left: 100%;
}


.order-warp {
  background-color: #fefcf9;
}
.van-grid-item >>> .van-grid-item__content {
  padding: 10px;
}
.van-grid-item >>> .van-grid-item__text {
  margin-top: 5px;
}
.userinfo-warp {
  height: 140px;
  display: flex;
  align-items: center;
}
.cells-warp {
  padding: 5px;
}
.user-left{
  display: flex;
  justify-content: center;
  flex:1;

}
.user-left>>>.van-image__img{
  border:2px solid #fff;
}
.user-left>>>img{
    width: 70px;
    height: 70px;
    border-radius: 5px;
}
.user-right {
    flex:2;
  display: flex;
  /* justify-content: center; */
  color: #fff;
  /* font-weight:500 ; */
  align-items: center;
  z-index: 9999;
}
.van-grid >>> .van-grid-item {
  margin-top: -10px;
}
.van-grid-item >>> .van-image {
  width: 40px;
  height: 40px;
}
.van-grid-item >>> span {
  font-size: 14px;
  margin-top: 5px;
}
.user-right-left{
    flex:2;
}
.user-right-right{
    flex:1;
}
.user-right-left>>>span{
    word-wrap:break-word;word-break:break-all;
}
</style>